import Vue from 'vue';
import Vuex from 'vuex';

import banco from './modules/banco';
import bancos from './modules/bancos';
import cliente from './modules/cliente';
import clientes from './modules/clientes';
import empresa from './modules/empresa';
import empresas from './modules/empresas';
import evento from './modules/evento';
import eventoDatos from './modules/eventoDatos';
import eventoStatus from './modules/eventoStatus';
import eventos from './modules/eventos';
import eventoCodigosPromocion from './modules/eventoCodigosPromocion';
import eventoGanadores from './modules/eventoGanadores';
import eventoEtapa from './modules/eventoEtapa';
import eventoEtapas from './modules/eventoEtapas';
import eventoImagenes from './modules/eventoImagenes';
import exportTransferencias from './modules/exportTransferencias';
import exportsTransferencias from './modules/exportsTransferencias';
import generos from './modules/generos';
import importMontosTransferir from './modules/importMontosTransferir';
import importParticipante from './modules/importParticipante';
import importParticipantes from './modules/importParticipantes';
import importsParticipantes from './modules/importsParticipantes';
import importTransferencias from './modules/importTransferencias';
import localidades from './modules/localidades';
import paises from './modules/paises';
import participante from './modules/participante';
import participanteDatos from './modules/participanteDatos';
import participanteReinscripcion from './modules/participanteReinscripcion';
import participantes from './modules/participantes';
import participantesSorteo from './modules/participantesSorteo';
import provincias from  './modules/provincias';
import searchList from './modules/searchList';
import sorteo from './modules/sorteo';
import sorteoGlobal from './modules/sorteoGlobal';
import sorteosGlobales from './modules/sorteosGlobales';
import sorteoGlobalEventos from './modules/sorteoGlobalEventos';
import spinnerProcesando from './modules/spinner-procesando';
import staff from './modules/staff';
import staffRecurso from './modules/staffRecurso';
import tiposEventos from './modules/tiposEventos';
import transferencia from './modules/transferencia';
import transferenciaDatos from './modules/transferenciaDatos';
import user from './modules/user';
import usuario from './modules/usuario';
import usuarios from './modules/usuarios';
import usuariosroles from './modules/usuariosroles';
import usuarioPerfil from './modules/usuarioPerfil';
import usuarioPWA from './modules/usuarioPWA';
import usuarioVeraz from './modules/usuarioVeraz';
import validacion from './modules/validacion';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        banco,
        bancos,
        cliente,
        clientes,
        empresa,
        empresas,
        evento,
        eventoDatos,
        eventoStatus,
        eventos,
        eventoCodigosPromocion,
        eventoGanadores,
        eventoEtapa,
        eventoEtapas,
        eventoImagenes,
        exportTransferencias,
        exportsTransferencias,
        generos,
        importMontosTransferir,
        importParticipante,
        importParticipantes,
        importsParticipantes,
        importTransferencias,
        localidades,
        paises,
        participante,
        participanteDatos,
        participanteReinscripcion,
        participantes,
        participantesSorteo,
        provincias,
        searchList,
        sorteo,
        sorteoGlobal,
        sorteosGlobales,
        sorteoGlobalEventos,
        spinnerProcesando,
        staff,
        staffRecurso,
        transferencia,
        transferenciaDatos,
        // tiposEventos,
        user,
        usuario,
        usuarios,
        usuariosroles,
        usuarioPerfil,
        usuarioPWA,
        usuarioVeraz,
        validacion
    }
});